// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/adminHome.css */

.admin-home {
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.welcome-section {
  text-align: center;
  margin-bottom: 30px;
}

.welcome-section h1 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 10px;
}

.welcome-section p {
  font-size: 1.1rem;
}

/* 快捷操作卡片 */
.quick-actions-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.quick-actions-card .card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0 !important;
  border: none;
}

.quick-actions-card .card-header h4 {
  margin: 0;
  font-weight: 600;
}

.quick-action-card {
  border-radius: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  height: 100%;
}

.quick-action-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.action-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.action-title {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 10px;
}

.action-description {
  font-size: 0.9rem;
  line-height: 1.4;
}

/* 最近活动和系统信息 */
.recent-activity-card,
.system-info-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.recent-activity-card .card-header,
.system-info-card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 12px 12px 0 0 !important;
}

.recent-activity-card .card-header h5,
.system-info-card .card-header h5 {
  margin: 0;
  color: #495057;
  font-weight: 600;
}

/* 活动列表 */
.activity-list {
  max-height: 300px;
  overflow-y: auto;
}

.activity-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f4;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: white;
  font-size: 0.9rem;
}

.activity-content {
  flex: 1 1;
}

.activity-title {
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 3px;
}

.activity-time {
  font-size: 0.8rem;
}

/* 系统信息列表 */
.info-list {
  margin: 0;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f1f3f4;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 500;
  color: #495057;
}

.info-value {
  font-weight: 500;
}

.info-value code {
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.85rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-home {
    padding: 10px;
  }
  
  .welcome-section h1 {
    font-size: 1.8rem;
  }
  
  .welcome-section p {
    font-size: 1rem;
  }
  
  .action-icon {
    font-size: 2rem;
  }
  
  .action-title {
    font-size: 1rem;
  }
  
  .action-description {
    font-size: 0.8rem;
  }
  
  .activity-icon {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }
  
  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
}

/* 动画效果 */
.admin-home {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.quick-action-card {
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 边框颜色变体 */
.border-primary { border-color: #007bff !important; }
.border-success { border-color: #28a745 !important; }
.border-info { border-color: #17a2b8 !important; }
.border-warning { border-color: #ffc107 !important; }
.border-secondary { border-color: #6c757d !important; }
.border-dark { border-color: #343a40 !important; }
`, "",{"version":3,"sources":["webpack://./src/styles/adminHome.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,cAAc;AACd;;EAEE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA,SAAS;AACT;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX,kBAAkB,gCAAgC,EAAE;AACpD,kBAAkB,gCAAgC,EAAE;AACpD,eAAe,gCAAgC,EAAE;AACjD,kBAAkB,gCAAgC,EAAE;AACpD,oBAAoB,gCAAgC,EAAE;AACtD,eAAe,gCAAgC,EAAE","sourcesContent":["/* frontend/src/styles/adminHome.css */\n\n.admin-home {\n  padding: 20px;\n  background-color: #f8f9fa;\n  min-height: 100vh;\n}\n\n.welcome-section {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.welcome-section h1 {\n  color: #2c3e50;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.welcome-section p {\n  font-size: 1.1rem;\n}\n\n/* 快捷操作卡片 */\n.quick-actions-card {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n}\n\n.quick-actions-card .card-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 12px 12px 0 0 !important;\n  border: none;\n}\n\n.quick-actions-card .card-header h4 {\n  margin: 0;\n  font-weight: 600;\n}\n\n.quick-action-card {\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  height: 100%;\n}\n\n.quick-action-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);\n}\n\n.action-icon {\n  font-size: 2.5rem;\n  margin-bottom: 15px;\n}\n\n.action-title {\n  color: #2c3e50;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.action-description {\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n/* 最近活动和系统信息 */\n.recent-activity-card,\n.system-info-card {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.recent-activity-card .card-header,\n.system-info-card .card-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  border-radius: 12px 12px 0 0 !important;\n}\n\n.recent-activity-card .card-header h5,\n.system-info-card .card-header h5 {\n  margin: 0;\n  color: #495057;\n  font-weight: 600;\n}\n\n/* 活动列表 */\n.activity-list {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.activity-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f3f4;\n}\n\n.activity-item:last-child {\n  border-bottom: none;\n}\n\n.activity-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 15px;\n  color: white;\n  font-size: 0.9rem;\n}\n\n.activity-content {\n  flex: 1;\n}\n\n.activity-title {\n  font-weight: 500;\n  color: #2c3e50;\n  margin-bottom: 3px;\n}\n\n.activity-time {\n  font-size: 0.8rem;\n}\n\n/* 系统信息列表 */\n.info-list {\n  margin: 0;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #f1f3f4;\n}\n\n.info-item:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  font-weight: 500;\n  color: #495057;\n}\n\n.info-value {\n  font-weight: 500;\n}\n\n.info-value code {\n  background-color: #f8f9fa;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .admin-home {\n    padding: 10px;\n  }\n  \n  .welcome-section h1 {\n    font-size: 1.8rem;\n  }\n  \n  .welcome-section p {\n    font-size: 1rem;\n  }\n  \n  .action-icon {\n    font-size: 2rem;\n  }\n  \n  .action-title {\n    font-size: 1rem;\n  }\n  \n  .action-description {\n    font-size: 0.8rem;\n  }\n  \n  .activity-icon {\n    width: 32px;\n    height: 32px;\n    margin-right: 10px;\n  }\n  \n  .info-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n}\n\n/* 动画效果 */\n.admin-home {\n  animation: fadeIn 0.5s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.quick-action-card {\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 边框颜色变体 */\n.border-primary { border-color: #007bff !important; }\n.border-success { border-color: #28a745 !important; }\n.border-info { border-color: #17a2b8 !important; }\n.border-warning { border-color: #ffc107 !important; }\n.border-secondary { border-color: #6c757d !important; }\n.border-dark { border-color: #343a40 !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
